import React, { useState } from 'react';
import { useLang } from '../LangContext';

export default function FAQ() {
  const { t } = useLang();
  const [open, setOpen] = useState(null);

  return (
    <section id="faq" style={{ padding: '6rem 1.5rem', maxWidth: '700px', margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
        <div style={{
          display: 'inline-block',
          background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: '99px', padding: '4px 14px', marginBottom: '1rem',
        }}>
          <span style={{ fontSize: '11px', color: 'var(--text2)', fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            {t.faq.sectionBadge}
          </span>
        </div>
        <h2 style={{
          fontFamily: 'var(--font-display)', fontSize: 'clamp(1.6rem, 4vw, 2.4rem)',
          fontWeight: 800, letterSpacing: '-0.02em', color: 'var(--text)',
        }}>{t.faq.headline}</h2>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {t.faq.items.map((faq, i) => (
          <div key={i} style={{
            border: `1px solid ${open === i ? 'rgba(255,60,60,0.2)' : 'rgba(255,255,255,0.06)'}`,
            borderRadius: '12px',
            background: open === i ? 'rgba(255,60,60,0.04)' : 'var(--bg2)',
            overflow: 'hidden', transition: 'border-color 0.2s, background 0.2s',
          }}>
            <button onClick={() => setOpen(open === i ? null : i)} style={{
              width: '100%', padding: '1.1rem 1.25rem',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              background: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left', gap: '12px',
            }}>
              <span style={{ fontSize: '14px', fontWeight: 500, color: open === i ? 'var(--text)' : 'var(--text2)', transition: 'color 0.2s' }}>
                {faq.q}
              </span>
              <div style={{
                width: '24px', height: '24px', flexShrink: 0,
                border: `1px solid ${open === i ? 'rgba(255,60,60,0.3)' : 'rgba(255,255,255,0.1)'}`,
                borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'transform 0.25s, border-color 0.2s',
                transform: open === i ? 'rotate(45deg)' : 'rotate(0)',
              }}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={open === i ? 'var(--brand)' : 'var(--text3)'} strokeWidth="2.5">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
              </div>
            </button>
            <div style={{ maxHeight: open === i ? '200px' : '0', overflow: 'hidden', transition: 'max-height 0.3s ease' }}>
              <p style={{ padding: '0 1.25rem 1.1rem', fontSize: '13px', color: 'var(--text2)', lineHeight: 1.7, fontWeight: 300 }}>
                {faq.a}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
